import { render } from "./quotation-list.vue?vue&type=template&id=abf2b312"
import script from "./quotation-list.vue?vue&type=script&lang=js"
export * from "./quotation-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__